/* eslint-disable no-unused-vars */
import RecoveryService from '@/services/recovery';

export async function sendEmailRecoveryPassword({commit}, params) {
  const {data} = await RecoveryService.sendEmailRecoveryPassword(params);
  return data;
}